import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'workingTypes';
export const workTypesActions = makeActions(MODEL_NAME, 'id', 'working-types');

export const getAllWorkTypes = workTypesActions.getAll;
export const editWorkTypes = workTypesActions.edit;
export const createWorkTypes = workTypesActions.create;
export const getByIdWorkTypes = workTypesActions.getDataById;
